import { createSelector } from 'reselect';

export const PENNY = 'Penny';

const getQualities = ({ myself: { qualities } }) => qualities;

const output = (qualities) => {
  const penniesQuality = qualities.find(q => q.name === PENNY);
  if (!penniesQuality) {
    return 0;
  }
  return penniesQuality.level / 100;
};

export default createSelector([getQualities], output);